// extracted by mini-css-extract-plugin
module.exports = {"container":"i_HJ","item":"i_HK","label":"i_HL","name":"i_HM","messages":"i_HN","bubble":"i_HO"};